<app-menu></app-menu>
<mat-toolbar color="primary"> Promote Static Image Packs</mat-toolbar>
<div style="margin: auto">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="promoteForm" (ngSubmit)="submit()">
        <mat-card class="mat-elevation-z0 card-padding">
          <mat-card-subtitle>From area to area</mat-card-subtitle>
          <mat-radio-group formControlName="area">
            <mat-radio-button
              class="col-lg-2"
              *ngFor="let v of areas"
              id="{{ v }}"
              [value]="v"
            >{{ v }}</mat-radio-button
            >
          </mat-radio-group>
        </mat-card>
        <mat-card class="mat-elevation-z0 card-padding">
          <mat-card-subtitle>Status</mat-card-subtitle>
          <mat-checkbox
            class="col-sm-2"
            formControlName="notPromoted"
            [value]="promoteSet.notPromoted"
          >not promoted
          </mat-checkbox
          >
          <mat-checkbox
            class="col-sm-2"
            formControlName="toPreProd"
            [value]="promoteSet.toPreProd"
          >to Pre-Prod
          </mat-checkbox
          >
          <mat-checkbox
            class="col-sm-2"
            formControlName="toProd"
            [value]="promoteSet.toProd"
          >to Prod
          </mat-checkbox
          >
        </mat-card>
        <mat-card class="mat-elevation-z0 card-padding">
          <mat-form-field class="col-sm-6">
            <input
              type="text"
              matNativeControl
              placeholder="Enter Static Image Pack Name"
              label="Enter Static Image Pack Name"
              formControlName="fileName"
              id="deploymentSetName"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selectedItem($event)"
            >
              <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </mat-card>

        <mat-card class="mat-elevation-z0 card-padding">
          <mat-card-subtitle>Last uploaded from-to</mat-card-subtitle>
          <mat-form-field appearance="fill" class="col-sm-6">
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate formControlName="from" placeholder="From"/>
              <input matEndDate formControlName="to" placeholder="To"/>
            </mat-date-range-input>

            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </mat-card>

        <mat-card class="mat-elevation-z0 card-padding">
          <table mat-table [dataSource]="dataSource" matSort>
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()"
                >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)"
                >
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="fileName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Static Image Pack Name</th>
              <td mat-cell *matCellDef="let element">{{ element.fileName }}</td>
            </ng-container>

            <ng-container matColumnDef="lastModifiedDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last upload</th>
              <td mat-cell *matCellDef="let element">
                {{ element.lastModifiedDate | date: "medium":"+0200":"de" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="lastPreprodPromoteDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last promotion to pre-prod</th>
              <td mat-cell *matCellDef="let element">
                {{ element.lastPreprodPromoteDate | date: "medium":"+0200":"de" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="lastProdPromoteDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last promotion to prod</th>
              <td mat-cell *matCellDef="let element">
                {{ element.lastProdPromoteDate | date: "medium":"+0200":"de" }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
            ></tr>
          </table>
        </mat-card>

        <mat-card class="mat-elevation-z0 d-flex justify-content-around">
          <button mat-raised-button color="primary" type="submit" [disabled]="selection.selected.length === 0">
            Promote
          </button>
          <button mat-raised-button color="accent" (click)="revert()">
            Reset
          </button>
        </mat-card>
      </form>
    </mat-card-content>
  </mat-card>
</div>
